import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {DatePipe} from '@angular/common';
import {VanBanDenXL} from '../../../../models/vanbanden/vanbandenxl';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {CommandUtil} from '../../../../global/commandutil';
import {ToTrinhXuLy} from '../../../../models/totrinh/totrinhxuly';
import {YeuCauXuLy} from '../../../../models/yeucau/yeucauxuly';
import {DomSanitizer} from '@angular/platform-browser';
import {Sessioncommand} from '../../../../global/sessioncommand';
@Component({
  templateUrl: './danhsach.component.html',
  encapsulation: ViewEncapsulation.None

})
export class DanhSachTHYeuCauComponent implements OnInit, AfterViewInit {

  public id: number = -1;
  public language = language;
  private thamKhao: number = 0;
  private staffId: number = Sessioncommand.staffId;
  public  onClose: Subject<boolean>;
  public yeuCauXuLyList: YeuCauXuLy[] = [];
  constructor(

    public toastr: ToastrService,
    public datepipe: DatePipe,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public commandUtil: CommandUtil,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();

  }


  public edit(yeuCauList: YeuCauXuLy[]) {
    this.yeuCauXuLyList = yeuCauList;

  }

  public show(yeuCauList: YeuCauXuLy[], thamKhao: number) {
    this.thamKhao = thamKhao;
    this.yeuCauXuLyList = yeuCauList;

  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }


}

